import { Check, Heart, Shield } from "lucide-react";

export default function WhyChooseUs() {
  const reasons = [
    "One Call To Solve Everything",
    "Friendly Available Local Experts",
    "Quality Service Every Time",
    "Fixes Preventing Future Problems",
    "EZ Maintenance Plans To Help You Win",
  ];

  return (
    <section id="why-choose-us" className="py-20 bg-white relative overflow-hidden">
      {/* Background Logo */}
      <img src="/manus-storage/watermark-800_50cb7eab_85566717.webp" srcSet="/manus-storage/watermark-550_5637eab4_c23ac34b.webp 550w, /manus-storage/watermark-800_50cb7eab_85566717.webp 800w, /manus-storage/watermark-1100_194e6bcc_77393d31.webp 1100w" sizes="(min-width: 1280px) 800px, (min-width: 768px) 720px, 100vw" alt="" width={1100} height={1099} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-center opacity-10 z-0" style={{objectFit: 'contain'}} />
      <div className="container relative z-10">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <p className="text-accent-text font-semibold uppercase tracking-wide">
                To Get Great Septic Service
              </p>
              <h2 className="text-4xl md:text-5xl font-bold text-foreground">
                You Need The Right Team
              </h2>
              <div className="flex flex-wrap gap-3 pt-4">
                <div className="flex items-center gap-2 bg-accent text-accent-foreground px-5 py-3 rounded-xl font-bold shadow-md">
                  <Heart className="w-6 h-6" />
                  <span className="text-base">Family Owned</span>
                </div>
                <div className="flex items-center gap-2 bg-primary text-primary-foreground px-5 py-3 rounded-xl font-bold shadow-md">
                  <Shield className="w-6 h-6" />
                  <span className="text-base">Veteran Owned</span>
                </div>
              </div>
            </div>

            <p className="text-lg text-foreground/70 leading-relaxed">
              Don't chase down contractors to get the septic services you need. Your local team has comprehensive services for as long as you need.
            </p>

            <div className="space-y-4">
              <h3 className="text-xl font-semibold text-foreground">
                What To Expect From Us:
              </h3>
              <ul className="space-y-3">
                {reasons.map((reason, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <div className="flex-shrink-0 mt-1">
                      <Check className="w-6 h-6 text-accent" />
                    </div>
                    <span className="text-foreground font-medium">{reason}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Right Content - Image Placeholder */}
          <div className="relative">
            <div className="bg-gradient-to-br from-primary/10 to-accent/10 rounded-lg aspect-square flex items-center justify-center overflow-hidden">
              <div className="text-center space-y-4">
                <div className="text-6xl">👷</div>
                <p className="text-foreground/60 font-medium">Professional Team Photo</p>
                <p className="text-sm text-foreground/50">High-quality team imagery builds trust</p>
              </div>
            </div>


          </div>
        </div>
      </div>
    </section>
  );
}
